import { BASE_URL } from "@/assets/constants/constants";
import { useTranslate } from "@/hooks/use-translate/useTranslate";
import { Link } from "react-router";

const NotFoundInspection = () => {
  const translate = useTranslate();
  return (
    <div
      data-testid="not-found-inspection-page"
      className="min-h-dvh flex items-center justify-center bg-neutral-100 px-4 text-ib-red-dark"
    >
      <div className="w-full max-w-md rounded-xl bg-white p-8 shadow-sm ring-1 ring-black/5 text-center">
        <div className="text-6xl font-ib-bold">404</div>
        <h1 className="mt-4 text-xl font-semibold ">
          {translate("notFoundInspection")}
        </h1>
        <Link
          to={`${BASE_URL}`}
          className="mt-6 inline-block rounded-md bg-ib-red-main px-4 py-2 text-sm font-medium text-white hover:bg-ib-red-dark"
        >
          {translate("goToInspections")}
        </Link>
      </div>
    </div>
  );
};

export default NotFoundInspection;
